/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrganisationRefFragment = { __typename: 'OrganisationRef', id: string, name: string };

export type AutomatedOnboardingTemplateRefFragment = { __typename: 'AutomatedOnboardingTemplateRef', id: string, title: string, owningSystemOrganisationId: string };

export type OrganisationAutomatedOnboardingSettingsFragment = { __typename: 'OrganisationAutomatedOnboardingSettings', enabled: boolean, enabledTriggers: Array<Types.AutomatedOnboardingTrigger>, templateOrganisation?: { __typename: 'OrganisationRef', id: string, name: string } | null, selectableTemplateOrganisations: Array<{ __typename: 'OrganisationRef', id: string, name: string }>, exampleLead: { __typename: 'AutomatedOnboardingExampleLeadSettings', enabled: boolean, projectTitle: string, quoteTitle: string, template?: { __typename: 'AutomatedOnboardingTemplateRef', id: string, title: string, owningSystemOrganisationId: string } | null, clientCrmOrganisation?: { __typename: 'OrganisationRef', id: string, name: string } | null } };

export type OrganisationAutomatedOnboardingBox_SetOrganisationAutomatedOnboardingSettingsMutationVariables = Types.Exact<{
  input: Types.SetOrganisationAutomatedOnboardingSettingsInput;
}>;


export type OrganisationAutomatedOnboardingBox_SetOrganisationAutomatedOnboardingSettingsMutation = { setOrganisationAutomatedOnboardingSettings: { __typename: 'OrganisationAutomatedOnboardingSettings', enabled: boolean, enabledTriggers: Array<Types.AutomatedOnboardingTrigger>, templateOrganisation?: { __typename: 'OrganisationRef', id: string, name: string } | null, selectableTemplateOrganisations: Array<{ __typename: 'OrganisationRef', id: string, name: string }>, exampleLead: { __typename: 'AutomatedOnboardingExampleLeadSettings', enabled: boolean, projectTitle: string, quoteTitle: string, template?: { __typename: 'AutomatedOnboardingTemplateRef', id: string, title: string, owningSystemOrganisationId: string } | null, clientCrmOrganisation?: { __typename: 'OrganisationRef', id: string, name: string } | null } } };

export const OrganisationRefFragmentDoc = gql`
    fragment OrganisationRef on OrganisationRef {
  id
  name
}
    `;
export const AutomatedOnboardingTemplateRefFragmentDoc = gql`
    fragment AutomatedOnboardingTemplateRef on AutomatedOnboardingTemplateRef {
  id
  title
  owningSystemOrganisationId
}
    `;
export const OrganisationAutomatedOnboardingSettingsFragmentDoc = gql`
    fragment OrganisationAutomatedOnboardingSettings on OrganisationAutomatedOnboardingSettings {
  enabled
  templateOrganisation {
    id
    ...OrganisationRef
  }
  enabledTriggers
  selectableTemplateOrganisations {
    id
    ...OrganisationRef
  }
  exampleLead {
    enabled
    template {
      id
      ...AutomatedOnboardingTemplateRef
    }
    clientCrmOrganisation {
      id
      ...OrganisationRef
    }
    projectTitle
    quoteTitle
  }
}
    ${OrganisationRefFragmentDoc}
${AutomatedOnboardingTemplateRefFragmentDoc}`;
export const OrganisationAutomatedOnboardingBox_SetOrganisationAutomatedOnboardingSettingsDocument = gql`
    mutation OrganisationAutomatedOnboardingBox_SetOrganisationAutomatedOnboardingSettings($input: SetOrganisationAutomatedOnboardingSettingsInput!) {
  setOrganisationAutomatedOnboardingSettings(input: $input) {
    ...OrganisationAutomatedOnboardingSettings
  }
}
    ${OrganisationAutomatedOnboardingSettingsFragmentDoc}`;
export type OrganisationAutomatedOnboardingBox_SetOrganisationAutomatedOnboardingSettingsMutationFn = Apollo.MutationFunction<OrganisationAutomatedOnboardingBox_SetOrganisationAutomatedOnboardingSettingsMutation, OrganisationAutomatedOnboardingBox_SetOrganisationAutomatedOnboardingSettingsMutationVariables>;

/**
 * __useOrganisationAutomatedOnboardingBox_SetOrganisationAutomatedOnboardingSettingsMutation__
 *
 * To run a mutation, you first call `useOrganisationAutomatedOnboardingBox_SetOrganisationAutomatedOnboardingSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationAutomatedOnboardingBox_SetOrganisationAutomatedOnboardingSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationAutomatedOnboardingBoxSetOrganisationAutomatedOnboardingSettingsMutation, { data, loading, error }] = useOrganisationAutomatedOnboardingBox_SetOrganisationAutomatedOnboardingSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganisationAutomatedOnboardingBox_SetOrganisationAutomatedOnboardingSettingsMutation(baseOptions?: Apollo.MutationHookOptions<OrganisationAutomatedOnboardingBox_SetOrganisationAutomatedOnboardingSettingsMutation, OrganisationAutomatedOnboardingBox_SetOrganisationAutomatedOnboardingSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganisationAutomatedOnboardingBox_SetOrganisationAutomatedOnboardingSettingsMutation, OrganisationAutomatedOnboardingBox_SetOrganisationAutomatedOnboardingSettingsMutationVariables>(OrganisationAutomatedOnboardingBox_SetOrganisationAutomatedOnboardingSettingsDocument, options);
      }
export type OrganisationAutomatedOnboardingBox_SetOrganisationAutomatedOnboardingSettingsMutationHookResult = ReturnType<typeof useOrganisationAutomatedOnboardingBox_SetOrganisationAutomatedOnboardingSettingsMutation>;
export type OrganisationAutomatedOnboardingBox_SetOrganisationAutomatedOnboardingSettingsMutationResult = Apollo.MutationResult<OrganisationAutomatedOnboardingBox_SetOrganisationAutomatedOnboardingSettingsMutation>;
export type OrganisationAutomatedOnboardingBox_SetOrganisationAutomatedOnboardingSettingsMutationOptions = Apollo.BaseMutationOptions<OrganisationAutomatedOnboardingBox_SetOrganisationAutomatedOnboardingSettingsMutation, OrganisationAutomatedOnboardingBox_SetOrganisationAutomatedOnboardingSettingsMutationVariables>;